import { SvgIcon, type SvgIconProps } from './svgIcon'

export const AddIcon = ({
  width = 21,
  height = 21,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 21 21" {...props}>
    <path
      d="M10.24 5.28V15.12M5.32001 10.2H15.16M19.44 10.2C19.44 15.281 15.321 19.4 10.24 19.4C5.15899 19.4 1.03999 15.281 1.03999 10.2C1.03999 5.11898 5.15899 1 10.24 1C15.321 1 19.44 5.11898 19.44 10.2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </SvgIcon>
)
